import React from "react";
import { Autocomplete, TextField, Box } from "@mui/material";
import { COUNTRIES } from "../utils/utils";

export default function RegionSelector({ value, onChange, error }) {
  return (
    <Autocomplete
      size="small"
      options={COUNTRIES}
      disableClearable
      value={COUNTRIES.find((c) => c.code === value) || null}
      getOptionLabel={(option) => option.label}
      onChange={(event, newValue) => {
        onChange(newValue ? newValue.code : null);
      }}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          <img
            loading="lazy"
            width="20"
            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            alt=""
          />
          {option.label}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          helperText={error ? "Please select a region" : ""}
          FormHelperTextProps={{
            sx: { textAlign: "right" },
          }}
        />
      )}
    />
  );
}
